import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import { Layout } from 'components/layout';
import { useUser } from 'components/hooks';
import { privateRoutes } from 'routes';
import ParamsProvider from 'components/ParamsProvider';
import { ROUTES } from 'consts';
import { nikoRoutes } from 'features/niko';
import {
  Login,
  Dashboard,
  TemplateList,
  TemplateCreate,
  TemplateEdit,
  TemplateView,
  WorkflowList,
  WorkflowCreate,
  WorkflowEdit,
  WorkflowView,
  DocumentationList,
  DocumentationView,
  DataModelList,
  DataModelCreate,
  DataModelEdit,
  DataModelView,
  JobList,
  JobRunTemplate,
  JobRunWorkflow,
  ChangePassword,
  MacroExecute,
  InventoryList,
  InventoryCreate,
  InventoryEdit,
  CredentialList,
  CredentialCreate,
  CredentialEdit,
} from 'views';
import {Prueba} from "../views/Prueba";
//import Prueba from "../views/Prueba";



const Routes = () => {
  const { isSignedIn, user } = useUser();

  //(!isSignedIn && AUTH_ENABLED)
  return (
    <Router>
      { !isSignedIn ? (
        <Switch>
          <Route
            exact
            path={ROUTES.LOGIN}
            render={(props) => <Login {...props} />}
          />
          <Redirect to={ROUTES.LOGIN} />
        </Switch>
      ) : (
        <ParamsProvider>
          <Layout>
            <Switch>
              <Route
                exact
                path={ROUTES.HOME}
                render={(props) => <Dashboard {...props} />}
              />
              <Route
                exact
                path={ROUTES.TEMPLATE_LIST}
                render={(props) => <TemplateList {...props} />}
              />
              <Route
                exact
                path={ROUTES.MACRO_EXECUTE}
                render={(props) => <MacroExecute {...props} />}
              />
              <Route
                exact
                path={ROUTES.INVENTORY_LIST}
                render={(props) => <InventoryList {...props} />}
              />
              <Route
                exact
                path={ROUTES.INVENTORY_CREATE}
                render={(props) => <InventoryCreate {...props} />}
              />
              <Route
                exact
                path={ROUTES.INVENTORY_EDIT}
                render={(props) => <InventoryEdit {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.INVENTORY_EDIT}/:inventory`}
                render={(props) => <InventoryEdit {...props} />}
              />


              <Route
                exact
                path={ROUTES.CREDENTIAL_LIST}
                render={(props) => <CredentialList {...props} />}
              />
              <Route
                exact
                path={ROUTES.CREDENTIAL_CREATE}
                render={(props) => <CredentialCreate {...props} />}
              />
              <Route
                exact
                path={ROUTES.CREDENTIAL_EDIT}
                render={(props) => <CredentialEdit {...props} canEdit={true}/>}
              />
              <Route
                exact
                path={`${ROUTES.CREDENTIAL_EDIT}/:credentialId`}
                render={(props) => <CredentialEdit {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.CREDENTIAL_VIEW}/:credentialId`}
                render={(props) => <CredentialEdit {...props} />}
              />


              <Route
                exact
                path={ROUTES.TEMPLATE_CREATE}
                render={(props) => <TemplateCreate {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.TEMPLATE_EDIT}/:templateId`}
                render={(props) => <TemplateEdit {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.TEMPLATE_VIEW}/:templateId`}
                render={(props) => <TemplateView {...props} />}
              />
              <Route
                exact
                path={ROUTES.WORKFLOW_LIST}
                render={(props) => <WorkflowList {...props} />}
              />
              <Route
                exact
                path={ROUTES.WORKFLOW_CREATE}
                render={(props) => <WorkflowCreate {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.WORKFLOW_EDIT}/:workflowId`}
                render={(props) => <WorkflowEdit {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.WORKFLOW_VIEW}/:workflowId`}
                render={(props) => <WorkflowView {...props} />}
              />
              <Route
                exact
                path={ROUTES.DATA_MODEL_LIST}
                render={(props) => <DataModelList {...props} />}
              />
              <Route
                exact
                path={ROUTES.DATA_MODEL_CREATE}
                render={(props) => <DataModelCreate {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.DATA_MODEL_EDIT}/:projectId/:dataModel`}
                render={(props) => <DataModelEdit {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.DATA_MODEL_VIEW}/:projectId/:dataModel`}
                render={(props) => <DataModelView {...props} />}
              />
              <Route
                exact
                path={ROUTES.DOCUMENTATION_LIST}
                render={(props) => <DocumentationList {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.DOCUMENTATION_VIEW}/:document/:baseUrl`}
                render={(props) => <DocumentationView {...props} />}
              />
              <Route
                exact
                path={ROUTES.JOB_LIST}
                render={(props) => <JobList {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.JOB_RUN_WORKFLOW}/:jobId`}
                render={(props) => <JobRunWorkflow {...props} />}
              />
              <Route
                exact
                path={`${ROUTES.JOB_RUN_TEMPLATE}/:jobId`}
                render={(props) => <JobRunTemplate {...props} />}
              />
              <Route
                exact
                path={ROUTES.CHANGE_PASSWORD}
                render={(props) => <ChangePassword {...props} />}
              />
              {/* Rutas de features opcionales: en la build core la lista viene vacía y
                  `/niko` cae en el Redirect a HOME, como cualquier ruta ajena. */}
              {nikoRoutes()}
              <Route
                exact
                path='/test'
                render={(props) => <Prueba {...props} />}
              />
              { user.admin && privateRoutes.map((route, index) => route)}
              <Redirect to={ROUTES.HOME} />
            </Switch>
          </Layout>
        </ParamsProvider>
      )}
    </Router>
  );
};

export default Routes;
